import helpers from '../../utils/helpers';
import framesProcessingService from '../device/framesProcessingService';
import log from '../logger/log';
import pairingService from '../pairingService';
import HIDClient from './hidClient';
import hidReconnectHandlerService from './hidReconnectHandlerService';

const connect = async ({isNewDevice, onConnect, onError, isInitialConnect, onDeviceSelect}) => {
    try {
        const options = {
            onDeviceConnect: () => {
                framesProcessingService.createNew();
                hidReconnectHandlerService.clearHidReconnectHandlerState();
            },
            onDisconnected: async (isDisconnectedByUser) => {
                pairingService.onDeviceDisconnect(isDisconnectedByUser, isInitialConnect);
            },
        };
        const hidClient = new HIDClient(true, options);

        await hidClient.connectDevice({isNewDevice, onConnect});
        helpers.runFunction(onDeviceSelect);
    } catch (e) {
        log.debug(`iqosHidService: device connection failed, error: ${e}`);
        helpers.runFunction(onError, [e]);
        throw e;
    }
};

const isClientInitialized = () => {
    try {
        new HIDClient();

        return true;
    } catch (e) {
        return false;
    }
};

const disconnect = () => {
    const hidClient = new HIDClient();

    hidClient.disconnect();
};

const isDeviceConnected = () => {
    const hidClient = new HIDClient();

    return hidClient.isDeviceConnected();
};

const unmount = () => {};

export default {
    connect,
    disconnect,
    isClientInitialized,
    isDeviceConnected,
    unmount,
};
